export default __webpack_public_path__ + "static/uikit-2-6538a2d2da6a89c05ad34c3d8a1aa72a.png";